var SharedSpinnerView, SupportCMSModel, SupportFinePrintView, SupportFlashView, SupportInbentaModel, SupportUtilsHelper;

SupportFlashView = require('../views/flash_view');

SupportFinePrintView = require('../views/order_related/fine_print_view');

SupportCMSModel = require('../models/CMS');

SupportInbentaModel = require('../models/Inbenta');

SharedSpinnerView = require('../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = {
  delay: function(ms, func) {
    return setTimeout(func, ms);
  },
  flash: function(type, content, sticky) {
    var view;
    if (sticky == null) {
      sticky = false;
    }
    view = new SupportFlashView({
      type: type,
      content: content,
      sticky: sticky
    });
    view.render();
    return $('#flash_container').html(view.$el);
  },
  highlight: function($element, callback, className) {
    if (className == null) {
      className = 'flash_highlight';
    }
    $element.addClass(className);
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass(className);
      if (callback) {
        return callback();
      }
    });
  },
  highlightText: function($element, callback) {
    $element.addClass('flash_text');
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass('flash_text');
      if (callback) {
        return callback();
      }
    });
  },
  openLocation: function(url) {
    return window.open(url);
  },
  isFileUploadSupported: function() {
    return window.FileReader != null;
  },
  showLoading: function(div, height) {
    var hash, spinner;
    if (height == null) {
      height = "250px";
    }
    if ($(".g-spinner", div).length === 0) {
      div.empty();
      spinner = new SharedSpinnerView();
      hash = {
        container: div,
        id: "g-spinner",
        height: height
      };
      return spinner.show(hash);
    }
  },
  openLinksInNewTab: function(div_links) {
    return div_links.attr("target", "_blank");
  },
  replaceNewLineWithBreak: function(text) {
    return text != null ? text.replace(/\n|\\x0a/gi, '<br />') : void 0;
  },
  renderFinePrint: function() {
    var finePrintView;
    finePrintView = new SupportFinePrintView();
    return finePrintView.render();
  },
  textOverflowEllipsis: function(length) {
    return function() {
      return function(text, render) {
        var content, delimitedContent;
        content = render(text);
        content = content.trim();
        if (content.length > length) {
          delimitedContent = content.substring(0, length - 3) + '...';
          return '<span title="' + content + '">' + delimitedContent + '</span>';
        } else {
          return content;
        }
      };
    };
  },
  addToTrackingHub: function(c, sc) {
    var data;
    data = {
      category: c,
      subcategory: sc
    };
    return TrackingHub.add("support-app-user-dropdown-change", {
      data: data
    });
  },
  activateieHacks: function() {
    ieISODateStringHack();
    return ieStringTrimHack();
  },
  ieISODateStringHack: function() {
    if (!Date.prototype.toISOString) {
      if (!Date.prototype.toJSON) {
        Date.prototype.toJSON = function(key) {
          var f;
          f = function(n) {};
          if (n < 10) {
            "0" + n;
          } else {
            n;
          }
          return this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z";
        };
      }
      return Date.prototype.toISOString = Date.prototype.toJSON;
    }
  },
  ieStringTrimHack: function() {
    if (typeof String.prototype.trim !== 'function') {
      return String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }
  },
  isUserLogged: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return true;
    } else {
      return false;
    }
  },
  match: function(arg1, arg2) {
    var diff, split1, split2;
    split1 = arg1 != null ? arg1.split(";") : void 0;
    split2 = arg2 != null ? arg2.split(";") : void 0;
    diff = _.difference(split1, split2);
    return diff.length === 0;
  },
  addParameterToUrlConsideringTheHash: function(url, parameterName, parameterValue, atStart) {
    var cl, i, newQueryString, parameterParts, parameters, replaceDuplicates, sourceUrl, urlParts, urlhash;
    replaceDuplicates = true;
    if (url.indexOf("#") > 0) {
      cl = url.indexOf("#");
      urlhash = url.substring(url.indexOf("#"), url.length);
    } else {
      urlhash = "";
      cl = url.length;
    }
    sourceUrl = url.substring(0, cl);
    urlParts = sourceUrl.split("?");
    newQueryString = "";
    if (urlParts.length > 1) {
      parameters = urlParts[1].split("&");
      i = 0;
      while (i < parameters.length) {
        parameterParts = parameters[i].split("=");
        if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
          if (newQueryString === "") {
            newQueryString = "?";
          } else {
            newQueryString += "&";
          }
          newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : "");
        }
        i++;
      }
    }
    if (newQueryString === "") {
      newQueryString = "?";
    }
    if (atStart) {
      newQueryString = "?" + parameterName + "=" + parameterValue + (newQueryString.length > 1 ? "&" + newQueryString.substring(1) : "");
    } else {
      if (newQueryString !== "" && newQueryString !== "?") {
        newQueryString += "&";
      }
      newQueryString += parameterName + "=" + (parameterValue ? parameterValue : "");
    }
    return urlParts[0] + newQueryString + urlhash;
  },
  getURLParameter: function(name) {
    return decodeURI((RegExp(name + "=" + "(.+?)(&|$)").exec(location.search) || [null, null])[1]);
  },
  isCurrentOrderMarketRateDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_MARKET_RATE");
  },
  isCurrentOrderGetawaysTonightDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_TONIGHT");
  },
  isCurrentOrderGetawaysBookingDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_BOOKING");
  },
  isCurrentOrderGoodsDeal: function() {
    return this.isCurrentOrderGoodsShippingDeal() || this.isCurrentOrderGoodsVoucherDeal();
  },
  isCurrentOrderGoodsShippingDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_SHIPPING");
  },
  isCurrentOrderGoodsVoucherDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_VOUCHER");
  },
  isCurrentOrderLiveDeal: function() {
    return this.isCurrentOrderOfDealType("LIVE");
  },
  isCurrentOrderLocalDeal: function() {
    return this.isCurrentOrderOfDealType("LOCAL");
  },
  isCurrentOrderOfDealType: function(deal_type) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0) === deal_type;
  },
  isCurrentOrderEditable: function() {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.editable : void 0) === true;
  },
  isOrderPurchasedWithinHours: function(specifiedHours) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.hoursAfterPurchase : void 0) < specifiedHours;
  },
  isCurrentOrderGetawaysDeal: function() {
    return isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || isCurrentOrderGetawaysBookingDeal();
  },
  isCostcoDeal: function() {
    var ref, ref1;
    return window.isFromCostcoFaq || ((ref = Groupon.Support.ContentModel) != null ? ref.isCostcoDropdownCombination : void 0) || ((ref1 = Groupon.Support.currentOrder) != null ? ref1.isCostcoDeal : void 0);
  },
  checkIfCategoryIsAboutEditingOrCancelling: function() {
    return checkIfCategoryIdMatches("editing_or_canceling_an_order");
  },
  checkIfCategoryIdMatches: function(categoryId) {
    var ref;
    return ((ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0) === categoryId;
  },
  getCurrentUserFullName: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return (($.trim(currentUser.firstName)) + " " + ($.trim(currentUser.lastName))).trim();
    }
  },
  addMetaDataQueryParams: function(url) {
    url = SupportUtilsHelper.addInventoryServiceIdInQueryParams(url);
    url = SupportUtilsHelper.addCostcoDealInfoInQueryParams(url);
    return url;
  },
  addCostcoDealInfoInQueryParams: function(url) {
    var is_costco_deal;
    is_costco_deal = this.isCostcoDeal();
    if (is_costco_deal) {
      url = url + "&is_costco_deal=" + is_costco_deal;
    }
    return url;
  },
  addInventoryServiceIdInQueryParams: function(url) {
    var inventory_service_id, ref;
    inventory_service_id = (ref = Groupon.Support.currentOrder) != null ? ref.inventoryServiceId : void 0;
    if (inventory_service_id) {
      url = url + "&inventory_service_id=" + inventory_service_id;
    }
    return url;
  },
  setTrackingInformation: function(type, url) {
    TrackingHub.page.metadata.type = type;
    return OptimizeSuite.treatAsNewPage(url);
  },
  getMillisecondsOfUTCDateFromISOStringDate: function(ISOStringDate) {
    var base;
    base = 10;
    return Date.UTC(parseInt(ISOStringDate.substring(0, 4), base), parseInt(ISOStringDate.substring(5, 7), base) - 1, parseInt(ISOStringDate.substring(8, 10), base), parseInt(ISOStringDate.substring(11, 13), base), parseInt(ISOStringDate.substring(14, 16), base));
  },
  redirectToFaqHack: function() {
    var hash;
    hash = window.location.hash;
    if (hash.indexOf("#faqs:") > -1) {
      return window.location.assign("/faq" + hash);
    }
  },
  hideFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.hide();
      return floatingChatElement.children().hide();
    }
  },
  showFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.show();
      return floatingChatElement.children().show();
    }
  },
  getDealMerchantName: function() {
    var ref, ref1, reservationSource;
    if (isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || (isCurrentOrderGetawaysBookingDeal() && isIntl())) {
      reservationSource = this.getReservationSource(Groupon.Support.currentOrder);
      return reservationSource != null ? reservationSource.hotelName : void 0;
    } else {
      return (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0;
    }
  },
  isStaticLiveChat: function(mode) {
    return mode === 'static';
  },
  isBothLiveChats: function(mode) {
    return mode === 'both';
  },
  isFloatingLiveChat: function(mode) {
    return mode === 'floating';
  },
  getOrderInfoForBH: function(order) {
    var hash, ref;
    hash = {
      id: order != null ? order.id : void 0,
      country: window.country.name,
      dealId: order != null ? (ref = order.deal) != null ? ref.id : void 0 : void 0,
      channel: order != null ? order.DEAL_TYPE : void 0
    };
    if (window.showRedesign()) {
      hash.showActionButtonAsLinks = true;
    }
    return hash;
  },
  showRedesign: function() {
    var ref;
    return Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled() || window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0);
  },
  priorityViewsEnabled: function() {
    var ref, ref1;
    return ((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0) || ((ref1 = Groupon.Support.ContentModel) != null ? ref1.escalateToMerchant : void 0);
  },
  liveChatVisible: function(liveChatDOMElem) {
    var clearImgurl;
    clearImgurl = /images.boldchat.com\/images\/clear/;
    return (liveChatDOMElem != null) && !(_.isEmpty(liveChatDOMElem.attr('src'))) && !clearImgurl.test(liveChatDOMElem.attr('src'));
  },
  setLiveChatDisplayCallBack: function(liveChatDOMElem, liveChatDisplayCallback) {
    if (((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) != null) && !window.liveChatCallBackSet) {
      window.liveChatCallBackSet = true;
      return liveChatDOMElem.on('load', function() {
        return liveChatDisplayCallback();
      });
    } else if ((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) == null) {
      return window.liveChatCallBackSet = false;
    }
  },
  liveChatLinkVisible: function() {
    var liveChatImageElem;
    liveChatImageElem = $("#live-chat-link-container div a div");
    return !_.isEmpty(liveChatImageElem.text());
  },
  getReservationSource: function(currentOrder) {
    var ref;
    return (currentOrder != null ? currentOrder.reservation : void 0) || (currentOrder != null ? (ref = currentOrder.travelBookingInfo) != null ? ref.reservation : void 0 : void 0);
  },
  findGrouponQuantity: function(groupons) {
    var quantity;
    quantity = 0;
    if (groupons != null) {
      _.each(groupons, function(groupon) {
        if (groupon.availability) {
          if (groupon.availability.toLowerCase() !== 'refunded') {
            return quantity++;
          }
        }
      });
    }
    return quantity;
  },
  shouldShowOptimizedChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) && !window.priorityViewsEnabled();
  },
  shouldShowFlexibleChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showFlexibleContactChannels : void 0) && !window.priorityViewsEnabled();
  },
  hideFooterLinks: function() {
    return window.hideDOMElems($("#footer_dynamic_links"));
  },
  showFooterLinks: function() {
    return window.showDOMElems($("#footer_dynamic_links"));
  },
  shouldShowFlexibleFormsForUS: function() {
    return window.evaluate(experiments.shouldEnableFlexibleFormForUSWebFromCMS) && Groupon.Support.FeatureFlagModel.isShowFlexibleFormsForUSEnabled();
  },
  isCostcoDropdownCombination: function() {
    var category, costcoCategory, costcoSubcategory, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, subCategory;
    category = ((ref = Groupon.Support.ContentModel.getCategory()) != null ? (ref1 = ref.id) != null ? ref1.toLowerCase() : void 0 : void 0) || null;
    subCategory = ((ref2 = Groupon.Support.ContentModel.getSubCategory()) != null ? (ref3 = ref2.id) != null ? ref3.toLowerCase() : void 0 : void 0) || null;
    costcoCategory = ((ref4 = window.costcoDropdowns) != null ? (ref5 = ref4.category) != null ? ref5.toLowerCase() : void 0 : void 0) || null;
    costcoSubcategory = ((ref6 = window.costcoDropdowns) != null ? (ref7 = ref6.subcategory) != null ? ref7.toLowerCase() : void 0 : void 0) || null;
    return (category != null) && (category.indexOf(costcoCategory) > -1) && (subCategory != null) && (subCategory.indexOf(costcoSubcategory) > -1);
  }
};

module.exports = SupportUtilsHelper;

//# sourceMappingURL=data:application/json;base64,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
